export default "__VITE_ASSET__c8a2b76d__"